import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { FateDropdown } from 'fate-editor';
import { take } from 'rxjs/operators';
import { AppState, getMyAuth } from 'src/app/store/app.state';

/**Componente per la dropdown delle note possibili */
@Component({
  selector: 'app-note-dropdown',
  templateUrl: './note-dropdown.component.html',
  styleUrls: ['../editor-dropdowns.css']
})
export class NoteDropdownComponent implements FateDropdown, OnInit {
  /**Input, la stringa eventualmente selezionata */
  @Input()
  public value: string;
  /**Emettitore per il valore selezionato dalla dropdown */
  @Output() public valueChange = new EventEmitter<string>();

  /**Elenco dei valori di nota possibili */
  noteList = [];

  /**Indice elemento selezionato */
  public selected = 0;

  /**
   * Metodo che gestisce l'emissione del valore selezionato
   * @param value {any} il valore selezionato
   */
  public changeValue(value) {
    this.valueChange.emit('<span class="note" style="' + value.style + '" rel="' + value.rel + '">' + value.val + '</span>')
  }

  /**Metodo che gestisce la selezione del successivo */
  public selectNext() {
    this.selected++;
    if (this.selected >= this.noteList.length) {
      this.selected = this.noteList.length - 1;
    }
  };
  /**Metodo che gestisce la selezione del precedente */
  public selecPrevious() {
    this.selected--;
    if (this.selected < 0) {
      this.selected = 0;
    }
  };
  /**Metodo che conferma la selezione lanciando il metodo di cambio valore */
  public confirmSelection() {
    this.changeValue(this.noteList[this.selected]);
  };

  /**
   * Costruttore per NoteDropdownComponent
   * @param store {Store<AppState>} store a livello dell'applicazione
   */
  constructor(public store: Store<AppState>) { }

  /**Metodo dell'interfaccia OnInit nel quale vengono recuparati i tipi di nota possibili */
  ngOnInit() {
    this.store.select(getMyAuth).pipe(take(1)).subscribe(data => {
      this.noteList = data.noteTypeList.map(noteType => {
        let testEl = {
          style: 'background-color: ' + noteType.color,
          rel: '?',
          val: noteType.symbol.toUpperCase(),
          title: noteType.name
        };
        return testEl;
      });
    })
  }
}
